import { useGetApplicationDataQuery } from '../apis/apiApplication';
import { useMemo } from 'react';
import { ApplicationDataType } from '@ydistri/utils';
import { lowercaseFirstLetter } from '@ydistri/generic-utils';

type ApplicationDataAvailability = Record<ApplicationDataType, boolean>;

type ApplicationDataAvailabilityWithLoading = ApplicationDataAvailability & { isLoading: boolean };

export function useApplicationData(): ApplicationDataAvailabilityWithLoading {
  const { data: applicationData, isLoading } = useGetApplicationDataQuery(undefined);

  return useMemo(() => {
    const availability: ApplicationDataAvailability = {
      [ApplicationDataType.BRANDS]: false,
      [ApplicationDataType.DEPARTMENTS]: false,
      [ApplicationDataType.FORCE_QUANTITIES]: false,
      [ApplicationDataType.MINIMAL_LAYERS]: false,
      [ApplicationDataType.OPEN_PURCHASE_ORDERS]: false,
      [ApplicationDataType.SKU_CLASSES]: false,
      [ApplicationDataType.SKU_DELIVERY_DATA]: false,
    };

    applicationData?.forEach(curr => {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- we need to retype the value
      const field = lowercaseFirstLetter(curr.applicationDataType) as ApplicationDataType;

      if (field in availability) {
        availability[field] = curr.isAvailable;
      }
    });

    return {
      ...availability,
      isLoading,
    };
  }, [applicationData, isLoading]);
}
